module.exports = __webpack_public_path__ + "static/a-xx-150-art-234148285095bd0cae17b12f1ea89a6a.jpg";